import React from "react"

let renderLines = (atual, total) => {
    let lines = [];
    console.log(atual)
    for (let index = 0; index < total; index++) {
        lines.push();
        
    }
    return lines;
}

const IndicadorQuestao = ({atual, questoes}) => {
    
    return(<>
    <table className="q-linetable-h">
        <tbody>
        <tr>
    {questoes.map((x,i) =>{
        var curr = atual == i+1;
    return (<><td className={"q-line-h" + ( curr ? " active" : "")}></td></>)
    }
    )
    }
    </tr>
    <tr>
    {questoes.map((x,i) =>{
        var curr = atual == i+1;
    return (<><td>{(curr ? <><span className="questao-number">{atual}</span><span className="questao-shadow">/{questoes.length}</span></>: "")}</td></>)
    }
    )
    }
    
    </tr>
    </tbody>
    </table>
    <table className="q-linetable">
    <tbody>
{questoes.map((x,i) =>{
    var curr = atual == i+1;
return (<tr><td>{(curr ? <><span className="questao-number">{atual}</span><span className="questao-shadow">/{questoes.length}</span></>: "")}</td><td className={"q-line" + ( curr ? " active" : "")}></td></tr>)
}
)
}
</tbody>
</table>
</>
);}


export default IndicadorQuestao